const sndThemeScript = document.currentScript;
const sndPreviewThemeId = sndThemeScript?.dataset.sndThemeId;
const sndThemeRole = sndThemeScript?.dataset.sndThemeRole;

function sndPreserveThemePreview(link) {
  if (!sndPreviewThemeId || sndThemeRole === 'main' || !window.location.hostname.endsWith('.myshopify.com')) return;

  const destination = new URL(link.href, window.location.href);
  const canonicalHref = document.querySelector('link[rel="canonical"]')?.href;
  const canonicalHost = canonicalHref ? new URL(canonicalHref).hostname : null;
  const isStoreLink = destination.hostname === window.location.hostname || destination.hostname === canonicalHost;

  if (!isStoreLink || !['http:', 'https:'].includes(destination.protocol)) return;

  destination.protocol = window.location.protocol;
  destination.host = window.location.host;
  destination.searchParams.set('preview_theme_id', sndPreviewThemeId);
  destination.searchParams.set('_fd', '0');
  destination.searchParams.set('pb', '0');
  link.href = destination.toString();
}

document.addEventListener('click', (event) => {
  const internalLink = event.target.closest('a[href]');
  const menuLink = event.target.closest('menu-drawer a[href], header-drawer a[href]');

  if (internalLink) sndPreserveThemePreview(internalLink);
  if (!menuLink) return;

  const drawer = menuLink.closest('details');

  if (drawer) {
    drawer.removeAttribute('open');
    drawer.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }

  document.documentElement.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
  document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
});

const sndMobileFormStyles = `
  @media (max-width: 749px) {
    #app-embed[data-current-step='form'] {
      --app-embed-padding-x: 0px !important;
      --app-embed-padding-y: 0px !important;
    }

    #app-embed[data-current-step='form'] section[class*='_floating_'] {
      align-items: flex-end !important;
      justify-content: center !important;
      padding: 0 !important;
      background: rgba(13, 25, 22, .3) !important;
      backdrop-filter: blur(4px);
    }

    #app-embed[data-current-step='form'] section[class*='_formContainer_'][class*='_grid_'] {
      width: calc(100% - 24px) !important;
      max-width: 42rem !important;
      min-width: 0 !important;
      height: auto !important;
      max-height: calc(100svh - 24px) !important;
      margin: 12px !important;
      display: block !important;
      border: 1px solid rgba(22, 35, 31, .16) !important;
      border-radius: 18px !important;
      box-shadow: 0 24px 64px rgba(8, 17, 15, .24) !important;
      overflow: hidden auto !important;
    }

    #app-embed[data-current-step='form'] section[class*='_formContainer_'] > div[class*='_imageLoaded_'] {
      display: none !important;
    }

    #app-embed[data-current-step='form'] section[class*='_formContainer_'] > div[class*='_gridItemContent_'] {
      min-height: 0 !important;
      padding: 30px 24px 24px !important;
    }

    #app-embed[data-current-step='form'] div[class*='_formContainerCloseButtonPosition_'] {
      top: 16px !important;
      right: 16px !important;
    }

    #app-embed[data-current-step='form'] span[class*='_formCloseButton_'] {
      width: 32px !important;
      height: 32px !important;
      display: grid !important;
      place-items: center !important;
      border-radius: 50% !important;
      background: rgba(238, 233, 221, .92) !important;
    }
  }

  @media (max-width: 359px) {
    #app-embed[data-current-step='form'] section[class*='_formContainer_'][class*='_grid_'] {
      width: calc(100% - 16px) !important;
      max-width: calc(100% - 16px) !important;
      max-height: calc(100svh - 16px) !important;
      margin: 8px !important;
    }

    #app-embed[data-current-step='form'] section[class*='_formContainer_'] > div[class*='_gridItemContent_'] {
      padding: 26px 20px 20px !important;
    }
  }
`;

const sndObservedFormRoots = new WeakSet();

function sndStyleMobileForm(host) {
  const root = host.shadowRoot;

  if (!root) return false;

  if (!root.querySelector('#snd-mobile-form-styles')) {
    const style = document.createElement('style');
    style.id = 'snd-mobile-form-styles';
    style.textContent = sndMobileFormStyles;
    root.appendChild(style);
  }

  if (!sndObservedFormRoots.has(root)) {
    sndObservedFormRoots.add(root);
    new MutationObserver(() => sndStyleMobileForm(host)).observe(root, { childList: true });
  }

  return true;
}

function sndFindShopifyForms() {
  document.querySelectorAll('shopify-forms-embed').forEach(sndStyleMobileForm);
}

new MutationObserver(sndFindShopifyForms).observe(document.documentElement, { childList: true, subtree: true });
sndFindShopifyForms();

let sndFormAttempts = 0;
const sndFormTimer = window.setInterval(() => {
  sndFindShopifyForms();
  sndFormAttempts += 1;

  if (sndFormAttempts >= 40) window.clearInterval(sndFormTimer);
}, 250);

const sndMobileChatStyles = `
  @media (max-width: 749px) {
    .activator-nudge {
      left: 16px !important;
      right: auto !important;
      bottom: 16px !important;
    }

    .activator {
      width: 48px !important;
      min-width: 48px !important;
      padding: 0 !important;
      justify-content: center !important;
    }

    .activator__label {
      display: none !important;
    }
  }
`;

const sndObservedChatRoots = new WeakSet();

function sndStyleMobileChat(host) {
  const root = host.shadowRoot;

  if (!root) return false;

  if (!root.querySelector('#snd-mobile-chat-styles')) {
    const style = document.createElement('style');
    style.id = 'snd-mobile-chat-styles';
    style.textContent = sndMobileChatStyles;
    root.appendChild(style);
  }

  if (!sndObservedChatRoots.has(root)) {
    sndObservedChatRoots.add(root);
    new MutationObserver(() => sndStyleMobileChat(host)).observe(root, { childList: true });
  }

  return true;
}

function sndFindShopifyChat() {
  document.querySelectorAll('shopify-chat').forEach(sndStyleMobileChat);
}

new MutationObserver(sndFindShopifyChat).observe(document.documentElement, { childList: true, subtree: true });
sndFindShopifyChat();

let sndChatAttempts = 0;
const sndChatTimer = window.setInterval(() => {
  sndFindShopifyChat();
  sndChatAttempts += 1;

  if (sndChatAttempts >= 40) window.clearInterval(sndChatTimer);
}, 250);

function sndSyncMobileFloatingWidgets() {
  const mobileOverlayOpen =
    window.matchMedia('(max-width: 749px)').matches &&
    document.querySelector('details-modal details[open], header-drawer details[open]');

  document.querySelectorAll('shopify-chat, shopify-forms-embed').forEach((host) => {
    if (mobileOverlayOpen) {
      host.style.setProperty('display', 'none', 'important');
    } else {
      host.style.removeProperty('display');
    }
  });
}

document.addEventListener('toggle', () => window.setTimeout(sndSyncMobileFloatingWidgets), true);
window.addEventListener('resize', sndSyncMobileFloatingWidgets);
new MutationObserver(sndSyncMobileFloatingWidgets).observe(document.documentElement, {
  childList: true,
  subtree: true,
});
sndSyncMobileFloatingWidgets();
